"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.ConsolePromptCommands = void 0;
exports.ConsolePromptCommands = {
    "cancel": true,
    "overwrite": true,
    "overwriteAll": true,
    "skip": true,
    "skipAll": true
};
